import React from "react";
import { useParams } from "react-router-dom";

const Stepbar = (props) => {
  const { id, customBookId } = useParams();
  const {
    name,
    handleopen = () => { },
    preinfoCompleted,
    addtocart = () => { },
    handlePreinfoSave = () => { },
    savebookforlater = () => { },
    handletempsave = () => { },
  } = props;
  return (
    <div className="container worldbook-stepbar">
      <div className="row no-gutters space">
        <div className="col-12">
          <div className="d-flex align-item-center custom-flex">
            <div
              className={`action-button ${preinfoCompleted == "name" ? "disabled" : ""
                }`}
              onClick={() => {
                handleopen("name");
              }}
            >
              Customisations
            </div>
            <div
              className={`action-button ${preinfoCompleted == "bookinfo" ? "disabled" : ""
                }`}
              onClick={() => {
                handleopen("bookinfo");
              }}
            >
              Dedication
            </div>
            <div
              className={`action-button ${preinfoCompleted == "imageupload" ? "disabled" : ""
                }`}
               onClick={addtocart}
            >
               Save & Add to Cart
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default connect(Stepbar);
